// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9a0K-","left":"styles_left__3pXV_"};